import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTime = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 2.75A.75.75 0 0 1 4.75 2h14.5a.75.75 0 0 1 0 1.5h-1.886v3.52c0 1.501-.552 2.952-1.551 4.03a5.4 5.4 0 0 1-1.16.95c.423.257.814.575 1.16.95.999 1.078 1.551 2.529 1.551 4.03v3.52h1.886a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h1.887v-3.52c0-1.501.552-2.953 1.55-4.03a5.4 5.4 0 0 1 1.16-.95 5.4 5.4 0 0 1-1.16-.95c-.998-1.078-1.55-2.529-1.55-4.03V3.5H4.75A.75.75 0 0 1 4 2.75m4.137.75h7.727v3.52c0 1.139-.42 2.222-1.152 3.012-.73.787-1.706 1.218-2.712 1.218-1.005 0-1.982-.43-2.712-1.219S8.137 8.16 8.137 7.02zm1.151 10.469c.73-.788 1.707-1.219 2.712-1.219s1.983.43 2.713 1.219c.731.79 1.151 1.872 1.151 3.012V20.5H8.137v-3.52c0-1.139.42-2.222 1.151-3.011"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgTime;
